define('view/controller/review/ReviewFormView',['require','lib/view/FormView','lib/view/UnwrapBehavior'],function (require) {

    var FormView = require('lib/view/FormView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * reviews item view
     *
     * @class AddReviewView
     */
    return FormView.extend({

        template: '#reviews_add_view',

        ui: {
            submitButton : '#sb_submit_review',
            logoutButton: '#sb_client_review_logout',
            data : ':input'
        },
        events: {
            'click @ui.submitButton' : 'submitReview',
            'click @ui.logoutButton': 'logout',
            'keyup @ui.data': '_onInputKeyUp'
        },

        modelEvents:  {
            'sync': 'render',
            'change': 'render',
            'invalid' : 'render'
        },
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        _reviewsCollection: null,
        _reviewClientModel : null,
        _clientModel : null,

        initialize : function () {
            this._reviewsCollection = this.getOption('reviewsCollection');
            this._reviewClientModel = this.getOption('reviewClientModel');
            this._clientModel = this.getOption('clientModel');

            if(this._clientModel){
                this.listenTo(this._clientModel, 'sync', this._setUser);
            }

            this.listenTo(this._reviewClientModel, 'sync', this._setUser);
            this._setUser();
        },

        _setUser: function () {
            if(this._clientModel && this._clientModel.get('is_logged_in') && !this._reviewClientModel.get('logged_in')){
                this.model.set({
                    'logged_in': this._clientModel.get('is_logged_in'),
                    'name': this._clientModel.get('name'),
                    'image': this._clientModel.get('openid_img'),//no image??
                    'link': '#client/profile',
                    'provider' : 'client-login',
                    'provider-data' : this._clientModel.get('id')
                });
            } else {
                this.model.set({
                    'logged_in': this._reviewClientModel.get('logged_in'),
                    'name': this._reviewClientModel.get('feedback_user_name'),
                    'image': this._reviewClientModel.get('feedback_image_link'),
                    'link': this._reviewClientModel.get('feedback_user_link'),
                    'provider' : '',
                    'provider-data' : ''
                });
            }
        },

        submitReview: function () {
            this.model.set(this._getData(this.ui.data), {silent:true});
            this.model.save(null, {
                success: _.bind(function () {
                    this.triggerMethod('saved');

                    Backbone.Wreqr.radio.vent.trigger('event', 'review:saved');
                }, this)
            });
        },

        logout: function () {
            if(this._clientModel && this._clientModel.get('is_logged_in')){
                this._clientModel.set('is_logged_in' , false);
            }
            this._reviewClientModel.set('logged_in', false);
            this._reviewClientModel.save();
        },

        serializeData: function () {
            return this._serializeData();
        },
        
        _onInputKeyUp: function (event) {
            if (event.keyCode === this.KEY_ENTER) {
                if (jQuery(event.target).is('textarea')) {
                    if (!event.shiftKey) {
                        this.ui.submitButton.trigger('click');
                    }
                } else {
                    this.ui.submitButton.trigger('click');
                }
            }
        }

    });

});
